import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectFlowsOnSiteEnabled } from '../../../flow/selectors/FlowSelectors';
import { clearSpaceContentCountsAction, contentCountsRequest } from '../../actions/spaces/ContentCountsActions';
import { showContentTypes, toggleShowWorkbooksAsViews } from '../../actions/spaces/ContentExplorerFilterActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../selectors/ContentCountsSelector';
import { selectCurrentlyApplicableContentTypes, selectDefaultContentTypeFilterValues } from '../../selectors/ContentFilterSelectors';
import { SessionSiteSelectors } from '../../selectors/SessionInfoSelectors';
import { selectSpaceInfo } from '../../selectors/SpaceInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { SiteUserSpace, SiteUserSpaceDispatchProps, SiteUserSpaceStateProps } from './SiteUserSpace';

const mapStateToProps: MapStateToProps<SiteUserSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  showWorkbooksAsViews: state.contentExplorer.showWorkbooksAsViews,
  contentCounts: selectContentCounts<'siteuser'>(state, 'siteuser'),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  isDataAlertsEnabled: SessionSiteSelectors.isDataAlertsEnabled(state),
  isFlowsEnabled: selectFlowsOnSiteEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<SiteUserSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    filterSelected: showContentTypes,
    fetchUpdatedContentCounts: contentCountsRequest,
    toggleShowWorkbooksAsViews: toggleShowWorkbooksAsViews,
    clearContentCounts: clearSpaceContentCountsAction,
  },
  dispatch);

export const ConnectedSiteUserSpace = connect(mapStateToProps, mapDispatchToProps)(SiteUserSpace);
